// extracted by mini-css-extract-plugin
export default {"instructionsSentText":"zc9EUQfHFJITlfUXb8AZ"};